import { Component, EventEmitter, Input, Output } from '@angular/core';
import { contactsInvestigations, contactsProfileCompanyInformationView, contactsProfileContactInformationViewAssigned } from 'src/app/shared/helpers/auth-config/contacts.config';
import { IApiContact, IApiInvestigation } from 'src/app/shared/modules/graphql/types/types';
import { InvestigationService } from 'src/app/shared/services';

@Component({
  selector: 'app-client-info-popover',
  templateUrl: './client-info-popover.component.html',
  styleUrls: ['./client-info-popover.component.scss']
})
export class ClientInfoPopoverComponent {
  @Input() id: string = '';
  @Input() client: IApiContact = null;

  public authConfig = {
    contactsProfileContactInformationViewAssigned,
    contactsProfileCompanyInformationView,
    contactsInvestigations
  }
  public clientPopoverLoading = false;

  public data: IApiInvestigation = null;

  constructor(private investigationService: InvestigationService) {
  }

  handleIconClick() {
    this.clientPopoverLoading = true;
    this.investigationService.getInvestigationByIdForClientPopover(this.id).subscribe((response) => {
      this.clientPopoverLoading = false;
      this.data = response;
    }, error => {
      this.clientPopoverLoading = false;
    })
  }
}
